import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../api';
import './Configurations.css';

const PROVIDERS = {
  mts: { name: 'МТС', logo: '/images/providers/mts.png' },
  megafon: { name: 'Мегафон', logo: '/images/providers/megafon.png' },
  beeline: { name: 'Билайн', logo: '/images/providers/beeline.png' },
  rostelecom: { name: 'Ростелеком', logo: '/images/providers/rostelecom.png' },
  tele2: { name: 'Tele2', logo: '/images/providers/tele2.png' },
  wifi: { name: 'WiFi', logo: '/images/providers/wifi.png' }
};

const TIME_PERIODS = {
  night: {
    name: 'Ночь',
    icon: '🌙',
    time: '01:00-06:00',
    description: 'Минимальная фрагментация',
    difficulty: 'easy'
  },
  day: {
    name: 'День',
    icon: '☀️',
    time: '12:00-17:00',
    description: 'Средняя фрагментация',
    difficulty: 'medium'
  },
  evening: {
    name: 'Вечер',
    icon: '🌆',
    time: '18:00-23:00',
    description: 'Агрессивная фрагментация',
    difficulty: 'hard'
  }
};

const CONFIGURATIONS = {
  mts: {
    night: {
      protocol: 'VLESS-Reality',
      protocols: ['Reality', 'XHTTP'],
      successRate: 94,
      url: 'https://ams3.uspn.io/go/test',
      fragmentation: 'minimal',
      keysCount: 3,
      server: 'Нидерланды 🇳🇱'
    },
    day: {
      protocol: 'VLESS-Reality+XHTTP',
      protocols: ['Reality', 'XHTTP', 'WS'],
      successRate: 87,
      url: 'https://ams3.uspn.io/go/test?fragment=1&packets=tlshello&length=30-50&interval=5-15',
      fragmentation: 'medium',
      keysCount: 5,
      server: 'Нидерланды 🇳🇱'
    },
    evening: {
      protocol: 'VLESS-Reality+XHTTP+WS',
      protocols: ['Reality', 'XHTTP', 'WS', 'gRPC'],
      successRate: 79,
      url: 'https://ams3.uspn.io/go/test?fragment=1&packets=1-3&length=15-25&interval=2-5',
      fragmentation: 'aggressive',
      keysCount: 7,
      server: 'Нидерланды 🇳🇱'
    }
  },
  megafon: {
    night: {
      protocol: 'VLESS-Reality',
      protocols: ['Reality', 'Trojan'],
      successRate: 91,
      url: 'https://ams3.uspn.io/go/test',
      keysCount: 3,
      server: 'Нидерланды 🇳🇱'
    },
    day: {
      protocol: 'VLESS-Reality+XHTTP',
      protocols: ['Reality', 'XHTTP'],
      successRate: 84,
      url: 'https://ams3.uspn.io/go/test?fragment=1&packets=tlshello&length=30-50&interval=5-15',
      keysCount: 5,
      server: 'Нидерланды 🇳🇱'
    },
    evening: {
      protocol: 'VLESS-Reality+gRPC',
      protocols: ['Reality', 'XHTTP', 'gRPC'],
      successRate: 76,
      url: 'https://ams3.uspn.io/go/test?fragment=1&packets=1-3&length=15-25&interval=2-5',
      keysCount: 7,
      server: 'Нидерланды 🇳🇱'
    }
  },
  beeline: {
    night: {
      protocol: 'VLESS-Reality',
      protocols: ['Reality'],
      successRate: 89,
      url: 'https://ams3.uspn.io/go/test',
      keysCount: 2,
      server: 'Нидерланды 🇳🇱'
    },
    day: {
      protocol: 'VLESS-Reality+XHTTP',
      protocols: ['Reality', 'XHTTP'],
      successRate: 81,
      url: 'https://ams3.uspn.io/go/test?fragment=1&packets=tlshello&length=30-50&interval=5-15',
      keysCount: 4,
      server: 'Нидерланды 🇳🇱'
    },
    evening: {
      protocol: 'VLESS-Reality+WS',
      protocols: ['Reality', 'XHTTP', 'WS'],
      successRate: 73,
      url: 'https://ams3.uspn.io/go/test?fragment=1&packets=1-3&length=15-25&interval=2-5',
      keysCount: 6,
      server: 'Нидерланды 🇳🇱'
    }
  },
  rostelecom: {
    night: {
      protocol: 'VLESS-Reality',
      protocols: ['Reality', 'Trojan'],
      successRate: 92,
      url: 'https://ams3.uspn.io/go/test',
      keysCount: 3,
      server: 'Нидерланды 🇳🇱'
    },
    day: {
      protocol: 'VLESS-Reality+XHTTP',
      protocols: ['Reality', 'XHTTP'],
      successRate: 86,
      url: 'https://ams3.uspn.io/go/test?fragment=1&packets=tlshello&length=30-50&interval=5-15',
      keysCount: 5,
      server: 'Нидерланды 🇳🇱'
    },
    evening: {
      protocol: 'VLESS-Reality+gRPC',
      protocols: ['Reality', 'XHTTP', 'gRPC'],
      successRate: 78,
      url: 'https://ams3.uspn.io/go/test?fragment=1&packets=1-3&length=15-25&interval=2-5',
      keysCount: 7,
      server: 'Нидерланды 🇳🇱'
    }
  },
  tele2: {
    night: {
      protocol: 'VLESS-Reality',
      protocols: ['Reality'],
      successRate: 88,
      url: 'https://ams3.uspn.io/go/test',
      keysCount: 2,
      server: 'Нидерланды 🇳🇱'
    },
    day: {
      protocol: 'VLESS-Reality+XHTTP',
      protocols: ['Reality', 'XHTTP'],
      successRate: 80,
      url: 'https://ams3.uspn.io/go/test?fragment=1&packets=tlshello&length=30-50&interval=5-15',
      keysCount: 4,
      server: 'Нидерланды 🇳🇱'
    },
    evening: {
      protocol: 'VLESS-Reality+WS',
      protocols: ['Reality', 'XHTTP', 'WS'],
      successRate: 72,
      url: 'https://ams3.uspn.io/go/test?fragment=1&packets=1-3&length=15-25&interval=2-5',
      keysCount: 6,
      server: 'Нидерланды 🇳🇱'
    }
  },
  wifi: {
    night: {
      protocol: 'VLESS-Reality',
      protocols: ['Reality'],
      successRate: 95,
      url: 'https://ams3.uspn.io/go/test',
      keysCount: 2,
      server: 'Нидерланды 🇳🇱'
    },
    day: {
      protocol: 'VLESS-Reality',
      protocols: ['Reality'],
      successRate: 93,
      url: 'https://ams3.uspn.io/go/test',
      keysCount: 3,
      server: 'Нидерланды 🇳🇱'
    },
    evening: {
      protocol: 'VLESS-Reality+XHTTP',
      protocols: ['Reality', 'XHTTP'],
      successRate: 90,
      url: 'https://ams3.uspn.io/go/test?fragment=1&packets=tlshello&length=30-50&interval=5-10',
      keysCount: 4,
      server: 'Нидерланды 🇳🇱'
    }
  }
};

function Configurations() {
  const navigate = useNavigate();
  const [selectedProvider, setSelectedProvider] = useState('mts');
  const [selectedTime, setSelectedTime] = useState(null);
  const [recommendedTime, setRecommendedTime] = useState('night');
  const [user, setUser] = useState(null);
  const [points, setPoints] = useState(0);

  useEffect(() => {
    const currentHour = new Date().getHours();
    let recommended = 'night';

    if (currentHour >= 1 && currentHour < 6) {
      recommended = 'night';
    } else if (currentHour >= 12 && currentHour < 17) {
      recommended = 'day';
    } else if (currentHour >= 18 && currentHour < 24) {
      recommended = 'evening';
    }

    setRecommendedTime(recommended);

    // Load user and points
    if (window.Telegram?.WebApp) {
      const tg = window.Telegram.WebApp;
      const initDataUnsafe = tg.initDataUnsafe;
      if (initDataUnsafe.user) {
        setUser(initDataUnsafe.user);
        loadUserPoints();
      }
    }
  }, []);

  const loadUserPoints = async () => {
    try {
      const veraRes = await api.get('/vera/balance');
      if (veraRes.data) {
        setPoints(veraRes.data.total_points || 0);
      }
    } catch (error) {
      console.error('Ошибка загрузки очков:', error);
      setPoints(0);
    }
  };

  const getDifficultyBadge = (difficulty) => {
    const badges = {
      easy: { text: 'Легко', color: '#7ED321' },
      medium: { text: 'Средне', color: '#F5A623' },
      hard: { text: 'Сложно', color: '#D0021B' }
    };
    return badges[difficulty] || badges.easy;
  };

  const copyToClipboard = (text) => {
    navigator.clipboard.writeText(text)
      .then(() => {
        if (window.Telegram?.WebApp) {
          window.Telegram.WebApp.showPopup({
            title: 'Скопировано!',
            message: 'Конфигурация скопирована в буфер обмена',
            buttons: [{ type: 'ok' }]
          });
        }
      })
      .catch(() => alert('Ошибка при копировании'));
  };

  const openInHapp = async (configUrl, provider, timePeriod, protocols) => {
    try {
      // Generate connection link via API
      const response = await api.post('/happ/generate-link', {
        subscription_url: configUrl,
        provider: provider,
        time_period: timePeriod,
        country: 'NL',
        protocols: protocols,
        source: 'configurations'
      });

      if (response.data.connection_url) {
        // Open the connection URL which will redirect to Happ
        window.Telegram.WebApp.openLink(response.data.connection_url);
      } else {
        throw new Error('No connection URL received');
      }
    } catch (error) {
      console.error('Failed to generate Happ link:', error);
      // Fallback to clipboard copy
      navigator.clipboard.writeText(configUrl)
        .then(() => {
          if (window.Telegram?.WebApp) {
            window.Telegram.WebApp.showPopup({
              title: '📋 URL скопирован!',
              message: 'Конфигурация скопирована в буфер обмена.\n\nИнструкция:\n1. Откройте Happ\n2. Нажмите "+" → "Subscription"\n3. Вставьте скопированный URL\n4. Нажмите "Add"',
              buttons: [{ type: 'ok' }]
            });
          }
        })
        .catch(() => {
          if (window.Telegram?.WebApp) {
            window.Telegram.WebApp.showAlert('Ошибка при копировании URL');
          }
        });
    }
  };

  return (
    <div className="configurations-page">
      {/* Header with points like Home page */}
      <div className="config-header">
        <div className="points-display">
          <span className="points-icon">⭐</span>
          <span className="points-value">{points}</span>
          <span className="points-label">очков</span>
        </div>
        {user && (
          <div className="user-greeting">
            {user.first_name} 👋
          </div>
        )}
      </div>

      <div className="config-header-modern">
        <h1 className="config-title">🌐 Готовые конфигурации</h1>
        <p className="config-subtitle">Оптимизированные конфигурации для вашего провайдера</p>
      </div>

      {/* Quick Navigation Buttons */}
      <div className="config-quick-nav">
        <button
          className="quick-nav-btn back-btn"
          onClick={() => navigate('/')}
        >
          <span>←</span>
          <span>Назад</span>
        </button>
        <button
          className="quick-nav-btn testing-btn"
          onClick={() => navigate('/testing')}
        >
          <span>🧪</span>
          <span>Тестирование</span>
        </button>
      </div>

      <div className="config-section">
        <h2 className="section-header">Выберите провайдера</h2>
        <div className="provider-grid">
          {Object.entries(PROVIDERS).map(([key, provider]) => (
            <div
              key={key}
              className={`provider-card ${selectedProvider === key ? 'selected' : ''}`}
              onClick={() => setSelectedProvider(key)}
            >
              <div className="provider-logo-wrapper">
                <img src={provider.logo} alt={provider.name} className="provider-logo" />
              </div>
              <div className="provider-name">{provider.name}</div>
              {selectedProvider === key && <div className="provider-check">✓</div>}
            </div>
          ))}
        </div>
      </div>

      <div className="config-section">
        <h2 className="section-header">
          Конфигурации для {PROVIDERS[selectedProvider].name}
        </h2>

        <div className="time-configs">
          {Object.entries(TIME_PERIODS).map(([timeKey, timePeriod]) => {
            const config = CONFIGURATIONS[selectedProvider][timeKey];
            const difficulty = getDifficultyBadge(timePeriod.difficulty);
            const isRecommended = timeKey === recommendedTime;
            const isSelected = timeKey === selectedTime;

            return (
              <div
                key={timeKey}
                className={`time-config-card ${isSelected ? 'selected' : ''}`}
                onClick={() => setSelectedTime(timeKey)}
              >
                {isRecommended && (
                  <div className="recommended-badge">Рекомендуется</div>
                )}

                <div className="time-config-header">
                  <div className="time-info">
                    <span className="time-icon">{timePeriod.icon}</span>
                    <span className="time-name">{timePeriod.name}</span>
                    <span className="time-range">{timePeriod.time}</span>
                  </div>
                  <div className="difficulty-badge" style={{ background: difficulty.color }}>
                    {difficulty.text}
                  </div>
                </div>

                <div className="config-details">
                  <div className="config-row">
                    <span className="config-label">Сервер:</span>
                    <span className="config-value">{config.server}</span>
                  </div>
                  
                  <div className="config-row">
                    <span className="config-label">Протокол:</span>
                    <span className="config-value">{config.protocol}</span>
                  </div>

                  <div className="config-row">
                    <span className="config-label">Ключей:</span>
                    <span className="config-value-highlight">{config.keysCount} шт.</span>
                  </div>
                </div>

                <div className="config-meta">
                  <div className="success-rate-box">
                    <span className="success-rate-value">{config.successRate}%</span>
                    <span className="success-rate-label">успеха</span>
                  </div>

                  <div className="protocols-tags">
                    {config.protocols.map(proto => (
                      <span key={proto} className="protocol-tag">{proto}</span>
                    ))}
                  </div>
                </div>

                {isSelected && (
                  <div className="config-actions">
                    <button
                      className="copy-config-btn"
                      onClick={(e) => {
                        e.stopPropagation();
                        copyToClipboard(config.url);
                      }}
                    >
                      📋 Копировать URL
                    </button>

                    <button
                      className="happ-btn"
                      onClick={(e) => {
                        e.stopPropagation();
                        openInHapp(config.url, selectedProvider, timeKey, config.protocols);
                      }}
                    >
                      <img src="/images/providers/happ-logo.png" alt="Happ" className="happ-logo-btn" />
                      <span>Открыть в Happ</span>
                    </button>
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>

      <div className="config-section">
        <div className="testing-cta-banner">
          <div className="testing-cta-icon">🧪</div>
          <div className="testing-cta-content">
            <h3>Не нашли подходящую?</h3>
            <p>Попробуйте создать индивидуальную конфигурацию</p>
          </div>
          <button
            className="testing-cta-btn"
            onClick={() => navigate('/testing')}
          >
            Тестовая площадка →
          </button>
        </div>
      </div>
    </div>
  );
}

export default Configurations;
